import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  FORM_PAYMENT_ACTIVATION_RESET_STATE: null,

  FORM_PAYMENT_ACTIVATION_SET_CURRENT_STEP: null,

  FORM_PAYMENT_ACTIVATION_SET_CURRENT_STEP_NEXT: null,

  FORM_PAYMENT_ACTIVATION_SET_CURRENT_STEP_BACK: null,

  FORM_PAYMENT_ACTIVATION_UPDATE: null,

  FORM_PAYMENT_ACTIVATION_SAVE_DATA: null,

  FORM_PAYMENT_ACTIVATION_SAVE_DATA_SUCCESS: null,

  FORM_PAYMENT_ACTIVATION_SAVE_DATA_FAILED: null,

  FORM_PAYMENT_ACTIVATION_SUBMIT_DATA: null,

  FORM_PAYMENT_ACTIVATION_SUBMIT_DATA_SUCCESS: null,

  FORM_PAYMENT_ACTIVATION_SUBMIT_DATA_FAILED: null,

  FORM_PAYMENT_ACTIVATION_LOAD_DATA: null,

  FORM_PAYMENT_ACTIVATION_LOAD_DATA_SUCCESS: null,

  FORM_PAYMENT_ACTIVATION_LOAD_DATA_FAILED: null,

  FORM_PAYMENT_ACTIVATION_SET_DATA: null,

  FORM_PAYMENT_ACTIVATION_AVAILABLE_EWALLET: null,

  FORM_PAYMENT_ACTIVATION_AVAILABLE_EWALLET_SUCCESS: null,

  FORM_PAYMENT_ACTIVATION_AVAILABLE_EWALLET_FAILED: null,
});
